// extracted by mini-css-extract-plugin
module.exports = {"MainMenuItem":"MainMenuItem_MainMenuItem__1L-ss","Link":"MainMenuItem_Link__15va3","Submenu":"MainMenuItem_Submenu__1FqS5"};